import React, { Component } from "react";
import { Grid, Tab } from "semantic-ui-react";
import moment from "moment";
import { getpath } from "../actions/get-path";
import { getAction } from "../actions/get-action";
import { newfeedback } from "../actions/feedback";
import { bindActionCreators } from "redux";
import {
  createservice,
  getservice,
  grabservice
} from "../services/crudservice";
import { connect } from "react-redux";
import Estimator from "../components/estimates/estimator";
import EstimatorSimple from "../components/estimates/estimatorsimple";
import { hashHistory } from "react-router";

class CreateEstimate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rates: [],
      currentinfo: JSON.parse(window.localStorage.getItem("estimateInfo")),
      tminvparams: props.location.state.tminvparams
    };
  }
  // handlecreateestimate(est){
  //   estimate = {est}
  // }
  componentDidMount() {
    console.log("Estimate Info", this.props.location.state.estimateinfo, window.localStorage.getItem("estimateInfo"))
    this.props.getpath("Create Estimate", "calculator");
    grabservice("salarycodes")
      .then(codes =>
        codes.map(code => {
          return {
            key: code.code,
            text:
              code.description +
              " " +
              "(" +
              code.location +
              ")" +
              "$" +
              code.payrate,
            value: code
          };
        })
      )
      .then(rates => this.setState({ rates }));
  }
  createEstimate(est) {
    let disclaimerfixed =
      "This is a fixed price task estimate. The task will be charged in full the amount stated on the estimate total. This quote is valid till" +
      moment()
        .endOf("year")
        .format("MM/DD/YYYY");
    // assign estimate number
    let customer = this.props.customers.find(
      cust => cust.custnumber === this.state.tminvparams.custnumber
    );

    est = {
      ...est,
      custnumber: this.state.tminvparams.custnumber,
      locationCode: this.state.currentinfo.location.code,
      billingNbr: this.state.currentinfo.billing.id,
      disclaimer: disclaimerfixed,
      estimateNumber: customer.nextestnumber,
      customerapproval: "",
      creator: this.props.myinfo.empnumber,
      createDate: moment().format("YYYY-MM-DD")
    };
    //  est.estimateNumber = estformatnumber(est);
    console.log("Estimate", est);
    console.log(this.state.currentinfo, est);
    getservice("edfemployees", this.props.myinfo.reportsto).then(supervisor => {
      createservice("estimates", est)
        .then(response => {
          getservice("edfemployees", this.props.myinfo.reportsto).then(
            supervisor => {}
          );

          let notification = {
            importance: "A",
            senddate: est.createDate,
            toemp: this.props.myinfo.reportsto,
            tocustomer: null,
            fromemp: this.props.myinfo.empnumber,
            subject: "New Estimate",
            message: this.props.myinfo.firstname + " created a new estimate"
          };
          createservice("messages", notification);
          console.log("Estimate response", response);
          setTimeout(() => {
            hashHistory.push("/estimatereview/" + response.id);
            window.location.reload();
          }, 2000);
        })
        .catch(err => console.log(err));
    });
  }
  render() {
    const panes = [
      {
        menuItem: "Simple Estimator",
        render: () => (
          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={14} computer={10}>
                <EstimatorSimple
                  create
                  tminvparams={this.state.tminvparams}
                  rates={this.state.rates}
                  today={moment().format("MM/DD/YY")}
                  ref="estimator"
                  handlesave={est => {
                    return this.createEstimate(est);
                  }}
                  customers={this.props.customers}
                  currentinfo={this.state.currentinfo}
                  myinfo={this.props.myinfo}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )
      },
      {
        menuItem: "Advanced Estimator",
        render: () => (
          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={14} computer={10}>
                <Estimator
                  create
                  tminvparams={this.state.tminvparams}
                  rates={this.state.rates}
                  today={moment().format("MM/DD/YY")}
                  ref="estimator"
                  handlesave={est => {
                    return this.createEstimate(est);
                  }}
                  customers={this.props.customers}
                  currentinfo={this.state.currentinfo}
                  myinfo={this.props.myinfo}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )
      }
    ];
    return (
      <div>
        <Tab
          menu={{ secondary: true, pointing: true }}
          ref="estimator"
          panes={panes}
          defaultActiveIndex={0}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    myinfo: state.myinfo.employeeinfo,
    customers: state.custinfo.customers
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      newfeedback: newfeedback,
      getpath: getpath,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(CreateEstimate);



// WEBPACK FOOTER //
// ./src/containers/CreateEstimate.js